import { useState, useEffect } from "react";

export type Theme = "light" | "dark" | "system";

function applyTheme(theme: Theme) {
  const root = document.documentElement;
  const isDarkOS = window.matchMedia("(prefers-color-scheme: dark)").matches;
  if (theme === "dark" || (theme === "system" && isDarkOS)) {
    root.classList.add("dark");
  } else {
    root.classList.remove("dark");
  }
  if (theme === "system") {
    localStorage.removeItem("soc:theme");
  } else {
    localStorage.setItem("soc:theme", theme);
  }
}

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(
    () => (localStorage.getItem("soc:theme") as Theme) || "system",
  );

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  // Check for system theme changes
  useEffect(() => {
    if (theme !== "system") return;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (e: MediaQueryListEvent) => {
      const root = document.documentElement;
      if (e.matches) root.classList.add("dark");
      else root.classList.remove("dark");
    };
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [theme]);

  const setTheme = (next: Theme) => setThemeState(next);

  return { theme, setTheme };
}
